const button = () => ({
  clickOnButton(event) {
    this.$dispatch('click-button', event);
  },
});

export default button;
